//context
import { ActivityFeedContext } from '@/context/ActivityFeedContext';
import { useContext } from 'react';

//components
import { IconButtonWithTooltip, IconLibrary, LoadingSpinner } from 'thrive-components';
import DateFilter from '../activityFeedFilters/dateFilter/popOut/DateFilter';
import PopOutFeedFilter from '../activityFeedFilters/feedFilters/PopOutFeedFilters';


const PopOutFilterScreen = ({onBackButtonClick}: {onBackButtonClick: ()=>void}) => {
    const {showPopOutFilterScreen} = useContext(ActivityFeedContext);
    const loadingSpinnerSize = 20;    
    const backButtonLabel = 'Back to Editor Activity Feed';
    const className = "pop-out-feed-button space-left";
    const backButtonIcon = IconLibrary.ARROW_LEFT;

    return (
        <div className='pop-out-filter-menu'>
            <IconButtonWithTooltip 
                className={className}
                ariaLabel={backButtonLabel}
                iconName={backButtonIcon}
                onButtonClick={onBackButtonClick} 
                tooltipText={'Back to Activity Feed'}            
            />

            {showPopOutFilterScreen
                ?   <>
                    <PopOutFeedFilter />
                    <DateFilter />
                    </>
                :   <LoadingSpinner size={loadingSpinnerSize}/>
            }
      </div>
    );
};
export default PopOutFilterScreen